import { CheckIcon } from '@heroicons/react/24/outline';

export const SuccessIcon = () => (
  <div className="flex items-center rounded-full bg-teal-100 p-5">
    <CheckIcon className="size-8 text-teal-600" />
  </div>
);
